import { CreateBrandSchema } from "@redotech/redo-model/brand-types";
import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

export const createBrand = unaryRpc({
  name: "createBrand" as const,
  input: CreateBrandSchema,
  output: z.object({ id: z.string() }),
});
